module.exports = {"610426001":"监军街道","610426101":"店头镇","610426102":"常宁镇","610426104":"甘井镇","610426105":"马坊镇","610426108":"渠子镇","610426110":"永平镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610426.json
// module id = 2950
// module chunks = 0